import { useEffect, useState } from 'react';
import axios from 'axios';
import '../home/styles.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import { Link, useNavigate } from "react-router-dom";

import { Fade } from "react-awesome-reveal";
import Skeleton from 'react-loading-skeleton';
import { SkeletonBlogItem } from '../../components/comment/SkeletonBlogItem';
import { useDebounce } from 'use-debounce';
import { removeBaseUrl } from '../../utils';
import jQuery from 'jquery';

const Home = () => {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);

    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [keyword] = useDebounce(searchTerm, 500);
    const [searchResults, setSearchResults] = useState([]);
    const [isFetchingSearchResults, setIsFetchingSearchResults] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('wrapper').classList.remove('internal');
        document.getElementById('wrapper').classList.add('home');
        fetchHomeData();
        if (document.querySelector('#wp-admin-bar-edit a')) {
            document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
            document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=2&action=edit`;
        }
        // document.title = 'Wood Hammel';
        return (() => {
            document.getElementById('wrapper').classList.add('internal');
            document.getElementById('wrapper').classList.remove('home');
        })
    }, []);


    const fetchHomeData = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=home`);

            // if (data?.page?.yoast_title?.length > 0) {
            //     document.title = data?.page?.yoast_title;
            // }
            await fetchPosts();
            setPageContent(data?.page ?? null);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    const fetchPosts = async () => {
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=fetch_latest_blogs`);
            const results = data?.result ?? [];
            setPosts(results);
        } catch (err) {
            setPosts([]);
        }
    }

    const generateRandomWidth = () => {
        return `${Math.floor(Math.random() * 51) + 50}%`;
    };

    const fetchSearchResults = async (term) => {
        setIsFetchingSearchResults(true);
        const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_blogs_by_page&page_number=1&posts_per_page=1000&keyword=${term}&cat_id=-1`);
        setSearchResults(data?.blogs ?? []);
        setIsFetchingSearchResults(false);
    };

    useEffect(() => {
        setSearchResults([]);
        if (keyword?.length >= 3) {
            fetchSearchResults(keyword);
        }
    }, [keyword]);
    const onGoToFooter = () => {
        var elementTop = jQuery('#footer').offset()?.top ?? 0;
        var viewportHeight = jQuery(window).height();
        var newScrollTop = elementTop - (viewportHeight / 3);
      
        window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
    }


    return <Fade delay={1}>
        <div className='page-wrapper home'>
            <section id="banner" className='home-banner'>
                <div className='inner-wrapper'>
                    {!isFetchingPageData && <h1 dangerouslySetInnerHTML={{__html: pageContent?.banner?.title ?? ''}}></h1>}
                    {isFetchingPageData && <h1>
                        <Skeleton width={"80%"} />
                        <Skeleton width={"100%"} />
                    </h1>}
                    <div className='tags'>
                        {
                            !isFetchingPageData && pageContent?.banner?.tags?.map((it, index) => <div className='tag-item' key={index}>
                                <Link to={it?.block_link}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#024953"/>
                                    </svg>
                                    {it?.block_label}
                                </Link>
                            </div>)
                        }
                        {
                            isFetchingPageData && [1, 2, 3, 4, 5, 6]?.map((it, index) => <div className='tag-item' key={index}>
                                <Skeleton width="160px" height="36px" />
                            </div>)
                        }
                    </div>
                    <div className='field-wrapper'>
                        <div className='search-field-wrapper'>
                            <input type="text" name="keyword" value={searchTerm} onChange={(e) => {
                                setSearchTerm(e.target.value)
                            }} />
                            <div className={`placeholder-wrapper ${searchTerm?.length > 0 ? "none" : "flex"}`}>
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.35242 0C10.3224 0 12.2117 0.782651 13.6047 2.17578C14.9977 3.56891 15.7803 5.45839 15.7803 7.42857C15.7803 9.26857 15.1061 10.96 13.9976 12.2629L14.3061 12.5714H15.2089L20.9226 18.2857L19.2085 20L13.4948 14.2857V13.3829L13.1862 13.0743C11.8835 14.1829 10.1922 14.8571 8.35242 14.8571C6.38243 14.8571 4.49312 14.0745 3.10013 12.6814C1.70714 11.2882 0.924561 9.39875 0.924561 7.42857C0.924561 5.45839 1.70714 3.56891 3.10013 2.17578C4.49312 0.782651 6.38243 0 8.35242 0ZM8.35242 2.28571C5.49555 2.28571 3.21006 4.57143 3.21006 7.42857C3.21006 10.2857 5.49555 12.5714 8.35242 12.5714C11.2093 12.5714 13.4948 10.2857 13.4948 7.42857C13.4948 4.57143 11.2093 2.28571 8.35242 2.28571Z" fill="white"/>
                                </svg>
                                <span>What Can we Handle for You?</span>
                            </div>
                        </div>
                        {
                            searchTerm?.length >=3 && <div className='search-results-wrapper'>
                                {
                                    !isFetchingSearchResults &&  searchResults?.length > 0 && <ul>
                                        {
                                            searchResults?.map((it, index) => <li key={index}>
                                                <Link to={removeBaseUrl(it?.permalink)}>{it?.title}</Link>
                                            </li>)
                                        }
                                    </ul>
                                }
                                {
                                    !isFetchingSearchResults && searchResults?.length < 1 && <span>No Results</span>
                                }
                                {
                                    isFetchingSearchResults && <ul>
                                        {
                                            Array.from({length: 10}).map(it => {
                                                return <li key={it}>
                                                    <Skeleton width={generateRandomWidth()} />
                                                </li>
                                            })
                                        }
                                    </ul>
                                }
                            </div>
                        }
                    </div>
                    <div className='bannerBadge'>
                        <img src="https://www.mylawteam.com/wp-content/uploads/2026/10/super-lawyer-15yrs-badge.avif" alt="Super Lawyer Badge" width="300" height="418" />
                    </div>
                </div>
            </section>

            <section id="intro-section" className='home-intro'>
                <div className='inner-wrapper'>
                    <div className='intro-section'>
                        <div className='featured-image'>
                            {!isFetchingPageData && <img src={pageContent?.intro?.featured_image} />}
                            {isFetchingPageData && <Skeleton width="100%" height="350px" />}
                        </div>
                        <div className='intro-content'>
                            {!isFetchingPageData && <>
                                <h2>{pageContent?.intro?.title}</h2>
                                <h3>{pageContent?.intro?.sub_title}</h3>
                                <p dangerouslySetInnerHTML={{__html: pageContent?.intro?.intro_section_details}}></p>
                            </>}
                            {isFetchingPageData && <>
                                <h2><Skeleton width={generateRandomWidth()} /></h2>
                                <h3>
                                    <Skeleton width={generateRandomWidth()} />
                                    <Skeleton width={generateRandomWidth()} />
                                </h3>
                                <p>
                                    <Skeleton width={generateRandomWidth()} />
                                    <Skeleton width={generateRandomWidth()} />
                                    <Skeleton width={generateRandomWidth()} />
                                    <Skeleton width={generateRandomWidth()} />
                                    <Skeleton width={generateRandomWidth()} />
                                </p>
                            </>}
                        </div>
                    </div>
                </div>
            </section>

            <section id="testimonials-section" className="home-testimonials">
                <div className='inner-wrapper'>
                    <div id="section-header">
                        {!isFetchingPageData && <h2>{pageContent?.testimonials?.title}</h2>}
                        {isFetchingPageData && <h2><Skeleton width={generateRandomWidth()} /></h2>}
                    </div>
                    <div className='testimonials-wrapper'>
                        <div className='testimonials-repeater'>
                            {
                                !isFetchingPageData && pageContent?.testimonials?.testimonials?.map((block, index) => {
                                    return <div className='testimonial-item' key={index}>
                                        <span className='block-quote'>
                                            <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.76 12.16C6.66667 12.4267 7.36 12.9333 7.84 13.68C8.37333 14.3733 8.64 15.2267 8.64 16.24C8.64 17.52 8.24 18.56 7.44 19.36C6.64 20.16 5.65333 20.56 4.48 20.56C3.2 20.56 2.16 20.16 1.36 19.36C0.613334 18.5067 0.24 17.4667 0.24 16.24C0.24 15.6 0.293334 14.9867 0.4 14.4C0.56 13.76 0.853333 12.8533 1.28 11.68L4.64 0.639997H8.48L5.76 12.16ZM19.36 12.16C20.2667 12.4267 20.96 12.9333 21.44 13.68C21.9733 14.3733 22.24 15.2267 22.24 16.24C22.24 17.52 21.84 18.56 21.04 19.36C20.24 20.16 19.2533 20.56 18.08 20.56C16.8 20.56 15.76 20.16 14.96 19.36C14.2133 18.5067 13.84 17.4667 13.84 16.24C13.84 15.6 13.8933 14.9867 14 14.4C14.16 13.76 14.4533 12.8533 14.88 11.68L18.24 0.639997H22.08L19.36 12.16Z" fill="#00252A"/>
                                            </svg>
                                        </span>
                                        <span className='block-title'>{block.block_title}</span>
                                        <span className='block-content'>{block.block_content}</span>
                                        <span className='block-name'>{block.block_name}</span>
                                    </div>
                                })
                            }
                            {
                                isFetchingPageData && [1, 2].map(it => <div className='testimonial-item' key={it}>
                                    <span className='block-quote'>
                                        <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.76 12.16C6.66667 12.4267 7.36 12.9333 7.84 13.68C8.37333 14.3733 8.64 15.2267 8.64 16.24C8.64 17.52 8.24 18.56 7.44 19.36C6.64 20.16 5.65333 20.56 4.48 20.56C3.2 20.56 2.16 20.16 1.36 19.36C0.613334 18.5067 0.24 17.4667 0.24 16.24C0.24 15.6 0.293334 14.9867 0.4 14.4C0.56 13.76 0.853333 12.8533 1.28 11.68L4.64 0.639997H8.48L5.76 12.16ZM19.36 12.16C20.2667 12.4267 20.96 12.9333 21.44 13.68C21.9733 14.3733 22.24 15.2267 22.24 16.24C22.24 17.52 21.84 18.56 21.04 19.36C20.24 20.16 19.2533 20.56 18.08 20.56C16.8 20.56 15.76 20.16 14.96 19.36C14.2133 18.5067 13.84 17.4667 13.84 16.24C13.84 15.6 13.8933 14.9867 14 14.4C14.16 13.76 14.4533 12.8533 14.88 11.68L18.24 0.639997H22.08L19.36 12.16Z" fill="#00252A"/>
                                        </svg>
                                    </span>
                                    <span className='block-title'>
                                        <Skeleton width={"90%"} />
                                        <Skeleton width={"60%"} />
                                    </span>
                                    <span className='block-content'>
                                        {[1, 2, 3, 4, 5].map(_it => {
                                            return <Skeleton width={generateRandomWidth()} key={_it} />
                                        })}
                                    </span>
                                    <span className='block-name'><Skeleton width={generateRandomWidth()}/></span>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </section>

            <section id="booking-section" className='home-booking'>
                <div className='inner-wrapper'>
                    <div className='booking-cta-content'>
                        {!isFetchingPageData && <>
                            <h2>{pageContent?.booking_cta?.cta_title}</h2>
                            <p>{pageContent?.booking_cta?.cta_details}</p>
                            <button type="button" onClick={() => {
                                onGoToFooter()
                            }} className="react-button">{pageContent?.booking_cta?.cta_button?.button_label}</button>
                        </>}
                        {isFetchingPageData && <>
                            <h2><Skeleton width={generateRandomWidth()} /></h2>
                            <p>
                                {[1,2,3,4].map(it => <Skeleton width={generateRandomWidth()} key={it} />)}
                            </p>
                            <button type="button" onClick={() => {
                                onGoToFooter()
                            }} className="react-button">Book a Consultation</button>
                        </>}
                    </div>

                    <div className='booking-testimonials-section'>
                        <span className='quote'>
                            <svg width="34" height="28" viewBox="0 0 34 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.35276 28C12.1543 28 15.3669 25.0155 15.3669 20.8915C15.3669 16.4419 12.1543 13.7829 8.35276 13.7829C6.8 13.7829 5.35433 14.3798 4.28346 15.2481C4.06929 14.5969 3.9622 13.8915 3.9622 12.9147C3.9622 8.57364 7.81732 3.90698 12.315 2.00775L11.2976 0C3.53386 3.68992 0 9.93023 0 17.1473C0 18.938 0.32126 22.031 1.87402 24.4729C3.2126 26.5891 5.14016 28 8.35276 28ZM26.9858 28C30.8409 28 34 25.0155 34 20.8915C34 16.4419 30.8409 13.7829 26.9858 13.7829C25.4331 13.7829 24.0409 14.3798 22.9165 15.2481C22.7024 14.5969 22.5953 13.8915 22.5953 12.9147C22.5953 8.57364 26.4504 3.90698 30.948 2.00775L29.9307 0C22.1669 3.68992 18.6331 9.93023 18.6331 17.1473C18.6331 18.938 18.9543 22.031 20.5071 24.4729C21.8457 26.5891 23.8268 28 26.9858 28Z" fill="#00252A"/>
                            </svg>
                        </span>
                        <span className='details'>
                            {!isFetchingPageData && pageContent?.booking_cta?.booking_testimonial?.block_details}
                            {
                                isFetchingPageData && [1, 2, 3, 4, 5, 6]?.map(it => <Skeleton width={generateRandomWidth()} key={it} />)
                            }
                        </span>

                        <span className='ratings'>
                            <svg width="185" height="32" viewBox="0 0 185 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1758 1.80469L11.3672 9.59766L2.75391 10.8281C1.23047 11.0625 0.644531 12.9375 1.75781 14.0508L7.91016 20.0859L6.44531 28.582C6.21094 30.1055 7.85156 31.2773 9.19922 30.5742L16.875 26.5312L24.4922 30.5742C25.8398 31.2773 27.4805 30.1055 27.2461 28.582L25.7812 20.0859L31.9336 14.0508C33.0469 12.9375 32.4609 11.0625 30.9375 10.8281L22.3828 9.59766L18.5156 1.80469C17.8711 0.457031 15.8789 0.398438 15.1758 1.80469ZM52.9258 1.80469L49.1172 9.59766L40.5039 10.8281C38.9805 11.0625 38.3945 12.9375 39.5078 14.0508L45.6602 20.0859L44.1953 28.582C43.9609 30.1055 45.6016 31.2773 46.9492 30.5742L54.625 26.5312L62.2422 30.5742C63.5898 31.2773 65.2305 30.1055 64.9961 28.582L63.5312 20.0859L69.6836 14.0508C70.7969 12.9375 70.2109 11.0625 68.6875 10.8281L60.1328 9.59766L56.2656 1.80469C55.6211 0.457031 53.6289 0.398438 52.9258 1.80469ZM90.6758 1.80469L86.8672 9.59766L78.2539 10.8281C76.7305 11.0625 76.1445 12.9375 77.2578 14.0508L83.4102 20.0859L81.9453 28.582C81.7109 30.1055 83.3516 31.2773 84.6992 30.5742L92.375 26.5312L99.9922 30.5742C101.34 31.2773 102.98 30.1055 102.746 28.582L101.281 20.0859L107.434 14.0508C108.547 12.9375 107.961 11.0625 106.438 10.8281L97.8828 9.59766L94.0156 1.80469C93.3711 0.457031 91.3789 0.398438 90.6758 1.80469ZM128.426 1.80469L124.617 9.59766L116.004 10.8281C114.48 11.0625 113.895 12.9375 115.008 14.0508L121.16 20.0859L119.695 28.582C119.461 30.1055 121.102 31.2773 122.449 30.5742L130.125 26.5312L137.742 30.5742C139.09 31.2773 140.73 30.1055 140.496 28.582L139.031 20.0859L145.184 14.0508C146.297 12.9375 145.711 11.0625 144.188 10.8281L135.633 9.59766L131.766 1.80469C131.121 0.457031 129.129 0.398438 128.426 1.80469ZM166.176 1.80469L162.367 9.59766L153.754 10.8281C152.23 11.0625 151.645 12.9375 152.758 14.0508L158.91 20.0859L157.445 28.582C157.211 30.1055 158.852 31.2773 160.199 30.5742L167.875 26.5312L175.492 30.5742C176.84 31.2773 178.48 30.1055 178.246 28.582L176.781 20.0859L182.934 14.0508C184.047 12.9375 183.461 11.0625 181.938 10.8281L173.383 9.59766L169.516 1.80469C168.871 0.457031 166.879 0.398438 166.176 1.80469Z" fill="#037C8E"/>
                            </svg>
                        </span>

                        <span className='name'>
                            {!isFetchingPageData && pageContent?.booking_cta?.booking_testimonial?.block_name}
                            {isFetchingPageData && <Skeleton width="100px" />}
                        </span>
                    </div>
                </div>
            </section>

            <section id="featured-image-wrapper">
                <img src={"https://www.mylawteam.com/wp-content/uploads/2025/05/wood-hammel-hp-image-scaled.jpg"} />
            </section>

            <section id="articles-section" className='home-articles'>
                <div className='inner-wrapper'>
                    <div id="section-header">
                        <h2>Articles & FAQ</h2>
                        <Link to={"/articles/"} className="gradient-button">browse all articles</Link>
                    </div>

                    <div className='posts-wrapper'>
                        <div className='posts-repeater'>
                            {
                                !isFetchingPageData && posts?.map((it, index) => {
                                    return <div className='blog-item'>
                                        <Link to={removeBaseUrl(it?.permalink)} className='blog-title'>
                                            {it?.title}
                                        </Link>
                                        <div className='blog-meta'>
                                            <span className='author'>By {it?.author_name}</span>
                                            <span className='category'>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#024953"/>
                                                </svg>
                                                {it?.category?.name}
                                            </span>
                                        </div>
                                        <span className='excerpt'>
                                            {it?.excerpt?.length > 100 ? `${it?.excerpt?.substring(0, 100)}...` : it.excerpt} <Link to={removeBaseUrl(it?.permalink)}>Read more</Link>
                                        </span>
                                    </div>
                                })
                            }

                            {
                                isFetchingPageData && [1, 2, 3, 4, 5, 6].map(it => {
                                    return <SkeletonBlogItem key={it} />
                                })
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Fade>
}

export default Home;